export default [
  {
    path: '/entradas',
      name: 'Entradas',
    component: () => import(/* webpackChunkName: "Entradas" */ '../entradas/Entradas')
  }
]



// WEBPACK FOOTER //
// ./src/pages/entradas/router.js